(function () {
  var activeGiftWrap = null;

  function getBundledSections() {
    var sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true,
        detail: { sections: sectionsToBundle }
      })
    );
    return sectionsToBundle;
  }

  async function refreshCartFromSections(sectionsHtml) {
    var cartContent = await (await fetch(window.Shopify.routes.root + 'cart.js')).json();
    cartContent.sections = sectionsHtml || {};
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:change', {
        bubbles: true,
        detail: {
          baseEvent: 'gift-wrap:change',
          cart: cartContent
        }
      })
    );
  }

  function GiftWrap(root) {
    this.root = root;
    this.panel = root.querySelector('[data-gift-wrap-panel]');
    this.trigger = root.querySelector('[data-gift-wrap-open]');
    this.note = root.querySelector('[data-gift-wrap-note]');
    this.counter = root.querySelector('[data-gift-wrap-counter]');
    this.maxChars = parseInt(root.dataset.maxChars || '100', 10);
    this.noteProperty = root.dataset.noteProperty || 'Gift note';
    this.variantId = root.dataset.variantId;
    this.lineKey = root.dataset.lineKey || '';
    this.hasGiftWrap = root.dataset.hasGiftWrap === 'true';
    activeGiftWrap = this;
    this.bind();
    this.updateCounter();
  }

  GiftWrap.prototype.bind = function () {
    var self = this;

    this.root.addEventListener('click', function (event) {
      var openBtn = event.target.closest('[data-gift-wrap-open], [data-gift-wrap-edit]');
      if (openBtn && self.root.contains(openBtn)) {
        event.preventDefault();
        self.openPanel();
        return;
      }

      var closeBtn = event.target.closest('[data-gift-wrap-close]');
      if (closeBtn && self.root.contains(closeBtn)) {
        event.preventDefault();
        self.closePanel();
        return;
      }

      var removeBtn = event.target.closest('[data-gift-wrap-remove]');
      if (removeBtn && self.root.contains(removeBtn)) {
        event.preventDefault();
        self.remove();
        return;
      }

      var submitBtn = event.target.closest('[data-gift-wrap-submit]');
      if (submitBtn && self.root.contains(submitBtn)) {
        event.preventDefault();
        self.submit();
      }
    });

    if (this.note) {
      this.note.addEventListener('input', function () {
        self.updateCounter();
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && self.panel && !self.panel.hidden) {
        self.closePanel();
      }
    });
  };

  GiftWrap.prototype.updateCounter = function () {
    if (!this.note || !this.counter) return;
    var remaining = Math.max(this.maxChars - (this.note.value || '').length, 0);
    var template = this.counter.getAttribute('data-counter-template') || '{{ count }} characters remaining';
    this.counter.textContent = template.replace('__COUNT__', String(remaining)).replace('{{ count }}', String(remaining));
  };

  GiftWrap.prototype.openPanel = function () {
    if (!this.panel) return;
    this.lineKey = this.root.dataset.lineKey || this.lineKey || '';
    this.hasGiftWrap = this.root.dataset.hasGiftWrap === 'true' || !!this.lineKey;
    this.panel.hidden = false;
    this.root.classList.add('is-open');
    if (this.trigger) this.trigger.setAttribute('aria-expanded', 'true');
    if (this.note) {
      this.note.focus();
      this.updateCounter();
    }
    try {
      this.panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    } catch (e) {}
  };

  GiftWrap.prototype.closePanel = function () {
    if (!this.panel) return;
    this.panel.hidden = true;
    this.root.classList.remove('is-open');
    if (this.trigger) this.trigger.setAttribute('aria-expanded', 'false');
  };

  // Keep old method names as aliases for line-item edit handler
  GiftWrap.prototype.openModal = GiftWrap.prototype.openPanel;
  GiftWrap.prototype.closeModal = GiftWrap.prototype.closePanel;

  GiftWrap.prototype.setBusy = function (isBusy) {
    document.querySelectorAll('[data-gift-wrap-edit], [data-gift-wrap-submit], [data-gift-wrap-remove], [data-gift-wrap-open]').forEach(function (button) {
      if (isBusy) {
        button.setAttribute('disabled', 'disabled');
        button.setAttribute('aria-busy', 'true');
      } else {
        button.removeAttribute('disabled');
        button.removeAttribute('aria-busy');
      }
    });
  };

  GiftWrap.prototype.submit = async function () {
    if (!this.variantId) return;

    var noteValue = (this.note && this.note.value ? this.note.value.trim() : '').slice(0, this.maxChars);
    var properties = {};
    properties[this.noteProperty] = noteValue;

    this.setBusy(true);
    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

    try {
      var sections = getBundledSections();
      this.lineKey = this.root.dataset.lineKey || this.lineKey || '';
      this.hasGiftWrap = this.root.dataset.hasGiftWrap === 'true' || !!this.lineKey;

      if (this.hasGiftWrap && this.lineKey) {
        await fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: this.lineKey,
            quantity: 0,
            sections: sections.join(',')
          })
        });
      }

      var addResponse = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          items: [
            {
              id: Number(this.variantId),
              quantity: 1,
              properties: properties
            }
          ],
          sections: sections.join(','),
          sections_url: window.location.pathname
        })
      });

      var addJson = await addResponse.json();
      if (!addResponse.ok) {
        throw new Error(addJson.description || 'Unable to add gift wrap');
      }

      await refreshCartFromSections(addJson.sections);
      this.closePanel();
    } catch (error) {
      console.error(error);
      window.alert(error.message || 'Unable to update gift wrap');
    } finally {
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
      this.setBusy(false);
    }
  };

  GiftWrap.prototype.remove = async function () {
    this.lineKey = this.root.dataset.lineKey || this.lineKey || '';
    if (!this.lineKey) return;

    this.setBusy(true);
    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

    try {
      var sections = getBundledSections();
      var response = await fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: this.lineKey,
          quantity: 0,
          sections: sections.join(',')
        })
      });
      var json = await response.json();
      if (!response.ok) {
        throw new Error(json.message || 'Unable to remove gift wrap');
      }
      await refreshCartFromSections(json.sections);
    } catch (error) {
      console.error(error);
      window.alert(error.message || 'Unable to remove gift wrap');
    } finally {
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
      this.setBusy(false);
    }
  };

  function initGiftWrap(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-gift-wrap]').forEach(function (el) {
      if (el.dataset.giftWrapReady === 'true') return;
      el.dataset.giftWrapReady = 'true';
      new GiftWrap(el);
    });
  }

  document.addEventListener('click', function (event) {
    var editBtn = event.target.closest('[data-gift-wrap-edit]');
    if (!editBtn) return;
    if (editBtn.closest('[data-gift-wrap]')) return;

    event.preventDefault();
    initGiftWrap(document);
    if (activeGiftWrap) {
      activeGiftWrap.openPanel();
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    initGiftWrap(document);

    var cartDrawer = document.getElementById('cart-drawer');
    if (cartDrawer && window.MutationObserver) {
      var mo = new MutationObserver(function () {
        initGiftWrap(cartDrawer);
      });
      mo.observe(cartDrawer, { childList: true, subtree: true });
    }
  });

  document.addEventListener('cart:change', function () {
    setTimeout(function () {
      document.querySelectorAll('[data-gift-wrap]').forEach(function (el) {
        el.dataset.giftWrapReady = 'false';
      });
      activeGiftWrap = null;
      initGiftWrap(document);
    }, 50);
  });

  window.initGiftWrap = initGiftWrap;
})();
